import bulmaCollapsible from '@creativebulma/bulma-collapsible';

document.addEventListener("turbolinks:load", () => {
  if ($('.toggle-button').length) {
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible', {
      allowMultiple: true
    });
  }
});